import { ChevronLeft, BookOpen, Languages, Layers, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ReaderGuideStepProps {
  onBack: () => void;
  onComplete: () => void;
}

export function ReaderGuideStep({ onBack, onComplete }: ReaderGuideStepProps) {
  const { t } = useTranslation('common');
  
  const features = [
    {
      icon: BookOpen,
      title: t('onboarding.readerGuide.features.diverseGenres.title'),
      description: t('onboarding.readerGuide.features.diverseGenres.description'),
    },
    {
      icon: Languages,
      title: t('onboarding.readerGuide.features.multipleLanguages.title'),
      description: t('onboarding.readerGuide.features.multipleLanguages.description'),
    },
    {
      icon: Layers,
      title: t('onboarding.readerGuide.features.allLevels.title'),
      description: t('onboarding.readerGuide.features.allLevels.description'),
    },
    {
      icon: Sparkles,
      title: t('onboarding.readerGuide.features.qualityContent.title'),
      description: t('onboarding.readerGuide.features.qualityContent.description'),
    },
  ];

  return (
    <div className="reader-guide-step">
      <div className="step-header mb-8 text-center">
        <h3 className="text-2xl font-semibold text-gray-900 mb-3">
          {t('onboarding.readerGuide.title')}
        </h3>
        <p className="text-gray-600 text-lg">
          {t('onboarding.readerGuide.subtitle')}
        </p>
      </div>

      <div className="guide-content max-w-2xl mx-auto">
        <div className="features-list space-y-6 mb-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="feature-item flex gap-4 items-start"
              >
                <div className="feature-icon flex-shrink-0">
                  <div className="icon-wrapper flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary">
                    <Icon className="h-6 w-6" />
                  </div>
                </div>
                <div className="feature-content flex-1">
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">
                    {feature.title}
                  </h4>
                  <p className="text-gray-600">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="cta-section text-center bg-gradient-to-br from-primary/5 to-primary/10 rounded-lg p-8">
          <p className="text-gray-700 mb-6 text-lg">
            {t('onboarding.readerGuide.ctaDescription')}
          </p>
          <button
            onClick={onComplete}
            className="start-reading-btn rounded-lg bg-primary px-8 py-3 text-white font-semibold hover:bg-primary/90 transition-colors shadow-md hover:shadow-lg"
          >
            {t('onboarding.readerGuide.startExploring')}
          </button>
        </div>
      </div>

      {/* Navigation */}
      <div className="navigation-buttons mt-8">
        <button
          onClick={onBack}
          className="back-btn flex items-center gap-2 rounded-lg border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <ChevronLeft className="h-4 w-4" />
          {t('common.back')}
        </button>
      </div>
    </div>
  );
}

